import React from 'react';
import { TSchedulerProps, TColumn } from './Scheduler.types';
import GlobalGrid from '../../../components/GlobalGrid';
const columns: TColumn[] = [
  {
    field: 'name',
    headerText: 'Name',
    width: 40,
    allowEditing: true,
  },
  {
    field: 'rate',
    headerText: 'Rate',
    width: 40,
    allowEditing: true,
  },
  {
    field: 'description',
    headerText: 'Description',
    width: 40,
    allowEditing: true,
  },
];
const toolbarOptions: any = [
  'Add',
  'Edit',
  'Delete',
  'Update',
  {
    text: 'Refresh',
    tooltipText: 'Refresh',
    prefixIcon: 'e-repeat',
    id: 'refresh',
  },
  'ColumnChooser',
];

const Scheduler: React.FC<TSchedulerProps> = (
  props: TSchedulerProps
): React.ReactElement => {
  return (
    <GlobalGrid
      query=''
      height=''
      columns={columns}
      toolbarOptions={toolbarOptions}
      signalOfLoad={false}
     
    />
  );
};

export default Scheduler;
